import React, { useEffect } from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import LoadingPage from '@vlabs/shared/components/loading-page/LoadingPage';
import { permissions } from '@vlabs/shared/config';
import { useApiRequest, useFaceOcclusionIsAvailable } from '@vlabs/shared/hooks';
import {
  Divider, Grid, GridRow, GridCol, Fold,
} from '@vlabs/uikit';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  FaceQualitySubForm, FiltersSubForm, DeepfakeSubForm, LivenessSubForm, FaceOcclusionSubForm,
} from '@vlabs/pages/handlers/forms/index';

import { CommonSubForm, EstimationsSubForm, StoragePolicySubForm } from './forms';
import { Page, PageContent, PageHeader } from '@vlabs/monokit/shared/ui/page';

function VerifierFormPage() {
  const { t } = useTranslation();

  const { verifierId } = useParams();
  const { state: { data: verifier }, isLoading } = useApiRequest({
    apiRequest: apiContainer.lunaClient.verifiers.get,
    parameters: verifierId,
  });

  const formMethods = useForm({ defaultValues: verifier });
  const { reset, handleSubmit } = formMethods;
  useEffect(() => {
    reset(verifier);
  }, [verifier, reset]);

  // FIXME временное решение, в будущем добавлять StepFaceOcclusion по умолчанию
  const isFaceOcclusionAvailable = useFaceOcclusionIsAvailable();

  if (isLoading || !verifier) return <LoadingPage />;

  const onAction = (
    <ButtonWithPermissions
      permissions={{ rules: [permissions.verifier.modification] }}
      type="submit"
      variant="outlined"
    >
      {t('форма.submit')}
    </ButtonWithPermissions>
  );

  const onSubmit = async (values) => {
    await apiContainer.lunaClient.verifiers.update(verifierId, values);
    toast.success(`${t('verifiers:api.успешно обновлен')}.`);
  };

  return (
    <FormProvider {...formMethods}>
      <Page>
        <form onSubmit={handleSubmit(onSubmit)} style={{ flex: 1 }}>
          <PageContent>
          <PageHeader
            actions={onAction}
            title={t('verifiers:editForm.form title')}
          />
          <Grid>
            <GridRow>
              <GridCol cols={6}>
                <Fold
                  isOpen
                  title={t('verifiers:editForm.subforms.titles.common')}
                >
                  <CommonSubForm />
                </Fold>
                <Divider />

                <Fold
                  isOpen
                  title={t('verifiers:editForm.subforms.titles.defined attributes')}
                >
                  <EstimationsSubForm />
                </Fold>
                <Divider />

                <LivenessSubForm />
                <Divider />

                <DeepfakeSubForm />
                <Divider />

                <FaceQualitySubForm />
                <Divider />

                {!!isFaceOcclusionAvailable && (
                <React.Fragment>
                  <FaceOcclusionSubForm />
                  <Divider />
                </React.Fragment>
                )}
              </GridCol>

              <GridCol cols={6}>
                <Fold
                  isOpen
                  title={t('verifiers:editForm.subforms.titles.save parameters')}
                >
                  <StoragePolicySubForm />
                </Fold>
                <Divider />

                <Fold
                  isOpen
                  title={t('verifiers:editForm.subforms.titles.filters')}
                >
                  <FiltersSubForm />
                </Fold>
              </GridCol>
            </GridRow>
          </Grid>
        </PageContent>
        </form>
      </Page>
    </FormProvider>
  );
}

export default VerifierFormPage;
